import { datadogRum } from '@datadog/browser-rum';

export const DD_RUM = () => {
  if (!AppConfig.DATADOG.enabled) {
    return;
  }
  datadogRum.init({
    applicationId: AppConfig.DATADOG.applicationId,
    clientToken: AppConfig.DATADOG.clientToken,
    site: 'datadoghq.eu',
    service: AppConfig.DATADOG.service,
    env: AppConfig.DATADOG.env,
    version: AppConfig.DATADOG.version,
    sampleRate: 100,
    sessionReplaySampleRate: AppConfig.DATADOG.sessionReplaySampleRate,
    trackInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogRum.startSessionReplayRecording();
};
